import { EntityEnums } from "../enums";

export const actantPositionDict = {
  s: {
    value: EntityEnums.Position.Subject,
    label: "subject",
    info: "",
  },
  a1: {
    value: EntityEnums.Position.Actant1,
    label: "actant1",
    info: "",
  },
  a2: {
    value: EntityEnums.Position.Actant2,
    label: "actant2",
    info: "",
  },
  pa: {
    value: EntityEnums.Position.PseudoActant,
    label: "pseudo-actant",
    info: "",
  },
};
